import { createStore } from 'vuex'
import {TaskSprintStore} from "@/store/task-sprint";
import {MessageStore} from "@/store/messages";
import {EsecutoriStore} from "@/store/esecutori";
import {LavoriStore} from "@/store/lavori";
import {AttivitaStore} from "@/store/attivita";
import {NotificheStore} from "@/store/notifiche";
import {SocketStore} from "./socket";
export default createStore({
  modules: {
    taskSprint: TaskSprintStore,
    messageHandler:MessageStore,
    esecutori:EsecutoriStore,
    lavori:LavoriStore,
    attivita:AttivitaStore,
    notifiche:NotificheStore,
    socket: SocketStore
  },
  state:{
    requestsCount:0
  },
  mutations:{
    showLoader(state, item){},
    hideLoader(state, item){},
    showSimpleModal(state, item){
      return item;
    },
    showDettaglioTicket(state, item){
      return item;
    },
    addRequest(state, item){
      state.requestsCount+=1;
      return item;
    },
    removeRequest(state, item){
      state.requestsCount-=1;
      return item;
    },
    showMiniLoader(state, item){},
    hideMiniLoader(state, item){},
    startTimbratura(state, item){
      return item;
    },
    startInsertMessaggioTS(state, item){
      return item;
    },
  },
  actions:{
    showLoader(context){},
    hideLoader(context){},
    addRequest({commit}, data){
      commit("addRequest", data)
    },
    removeRequest({commit}, data){
      commit("removeRequest", data)
    },
    startShowDettaglioTicket({commit}, data){
      commit("showDettaglioTicket", data)
    },
    startTimbratura({commit}, data){
      commit("startTimbratura", data)
    },
    startInsertMessaggioTS({commit}, data){
      commit("startInsertMessaggioTS", data)
    }
  },
  getters:{
    getRequests: (state) => (status) => {
      return state.requestsCount;
    },
  }
})
function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
}